<template>
  <el-container>
    <el-header v-show='$route.path !== "/chat"'>
      <h3 class="title">
        <el-row class="block">
          <span>工单管理 > {{pageName}}</span>
        </el-row>
      </h3>
    </el-header>
    <el-main>
      <el-form :rules="rules" ref="ruleForm" :model="template" label-width="150px">
        <div>
          <el-form-item label="模板名称" prop="templateName">
            <el-input placeholder="请输入模板名称" v-model="template.templateName" :disabled ='template.id !== null && template.id !== undefined && template.id !== ""' style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="创建者">
            <el-input v-model="template.creator" style="width:200px" disabled></el-input>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-select placeholder="请选择模板类型" filterable v-model="template.type" :disabled ='template.id !== null'>
              <el-option
                v-for="item in templateTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div v-show="template.fieldGroups.length > 0 || !template.id" v-for="(group, index) in template.fieldGroups" :key="index" :name="index" >
          <div v-show="group.fields.length > 0"  style="border: 1px solid rgb(220, 223, 230);margin:0 0 20px 0">
            <div style="text-align: left; font-size: 20px;margin:10px 0;">{{group.groupName}}</div>
            <div v-for="(field, fieldIndex) in group.fields" :key="fieldIndex" :name="fieldIndex">
                  <el-form-item  :label="field.fieldName">
                    <el-input v-model="field.value" v-if="field.fieldType == 'textfield'" disabled  style="width:98%"></el-input>
                    <el-input v-model="field.value" v-if="field.fieldType == 'textfield_dynamic'" disabled style="width:98%"></el-input>
                    <el-input type="textarea" v-model="field.value" v-if="field.fieldType == 'textarea'"  maxlength="10" show-word-limit=true clearable resize='none' disabled  style="width:98%"></el-input>
                    <el-select v-model="field.value" filterable v-if="field.fieldType == 'select'" disabled  style="width:98%">
                      <div>
                        <el-option
                          v-for="option in field.fieldValues"
                          :key="option.id"
                          :label="option.val"
                          :value="option.id">
                        </el-option>
                      </div>
                    </el-select>
                    <el-select v-model="field.value" filterable  style="width:98%"
                    v-if="field.fieldType == 'select_dynamic' && field.fieldTag !== 'workorder_assignee' && field.fieldTag !== 'workorder_director'" disabled>
                      <el-option
                        v-for="option in field.fieldValues"
                        :key="option.id"
                        :label="option.val"
                        :value="option.id">
                      </el-option>
                    </el-select>
                    <el-cascader v-if="field.fieldType === 'select_dynamic' && field.fieldTag === 'workorder_assignee'" disabled  style="width:98%"
                      expand-trigger="hover"
                      :options="agents"
                      v-model="field.values">
                    </el-cascader>
                    <el-cascader v-if="field.fieldType === 'select_dynamic' && field.fieldTag === 'workorder_director'" disabled  style="width:98%"
                      expand-trigger="hover"
                      :options="agents"
                      v-model="field.values">
                    </el-cascader>
                    <el-button type="primary" v-if="field.fieldTag == 'linkSessionsAndCustomer'"  disabled>关联会话记录</el-button>
                    <el-button type="primary" v-if="field.fieldTag == 'linkSessionsAndCustomer'" disabled>关联客户</el-button>
                    <el-button type="primary" @click="deleteField(group,fieldIndex)" v-if="index !== 0 && !template.id" style="margin-left:10px">删除</el-button>
                  </el-form-item>
            </div>
          </div>

        </div>
        <div v-if="!template.id" style="width:100%;padding:0 30px;box-sizing:border-box;">
            <el-form-item>
              <el-select placeholder="请选择添加字段" v-model="currentField">
                <el-option
                  v-for="item in configFields"
                  :key="item.id"
                  :label="item.name"
                  :value="{fieldName:item.name,fieldId:item.id,fieldTag:item.tag,value:item.tag,fieldType:item.type,fieldValues:item.fieldValues}">
                </el-option>
              </el-select>
              <el-button type="primary" @click="addField" style="margin-left:5px">新增自定义字段</el-button>
            </el-form-item>
          </div>
      </el-form>
      <el-row type="flex" justify="end" v-show="loaded" style="margin-bottom:50px">
          <el-button size="medium" @click="goBack">返回</el-button>
          <el-button size="medium" type="primary" v-if='!template.id' @click="saveTemplate">保存</el-button>
          <el-button size="medium" type="primary" v-if='template.id && $store.state.order.orderPermission.auditTemplate && this.template.status === -1' @click="auditTemplate">审核通过</el-button>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: 'Template',
  props: {
    pageName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      template: {},
      templateTypes: [
        {
          label: '售前',
          value: 0
        }, {
          label: '售中',
          value: 1
        }, {
          label: '售后',
          value: 2
        }
      ],
      agents: [],
      currentGroup: {},
      currentField: {},
      configFields: [],
      templateHasLinkCustomer: false,
      rules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {

  },
  watch: {
    '$store.state.order.template': function(newFlag, oldFlag) {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.$store.state.order.template.id) {
        this.getTemplate(this.$store.state.order.template.id)
      } else {
        this.template = this.$store.state.order.template
        this.currentGroup = this.template.fieldGroups[1]
        this.loaded = true
      }

      this.getAllFields()
    },
    getAllFields() {
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/system/custom_field/get?categoryCode=').then(res => {
        this.configFields = res.data.data
      })
    },
    addField() {
      if (!this.currentField.fieldType) {
        this.$message.error('请选择自定义字段')
        return
      }
      this.currentField.value = ''
      this.currentField.displayOrder = this.currentGroup.fields.length + 1
      this.currentGroup.fields.push(this.currentField)
    },
    getTemplate(templateId) {
      this.$http.get(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/template/get?templateId=' + templateId).then(res => {
        this.template = res.data.data
        this.currentGroup = this.template.fieldGroups[1]
        this.loaded = true
      })
    },
    deleteField(group, index) {
      group.fields.splice(index, 1)
    },
    saveTemplate() {
      const that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.template.creator = this.$store.state.user.userInfo.userName
          that.$http.post(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/template/create', {
            data: this.template
          }).then(function(response) {
            that.$emit('goBack', false)
          }).catch(function(error) {
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    auditTemplate() {
      const that = this
      this.$http.post(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/template/audit', {
        data: this.template.id
      }).then(function(response) {
        that.$emit('goBack', false)
      }).catch(function(error) {
        console.log(error)
      })
    },

    goBack() {
      this.$emit('goBack', false)
    }
  },

  beforeRouteLeave: function(to, from, next) {
    this.$store.commit('order/saveTemplate', this.template)
    next()
  }
}
</script>

<style>
</style>
